'use client';

import {
    IQuestionFilterParams,
    QuestionsSortByEnum,
} from '@services/live-event/live-event.model';
import {createProvidedStore} from '@utils/createProvidedStore';
import createZustandStore from '@utils/createZustandStore';

interface IQuestionsStore {
    sortByFilter: IQuestionFilterParams['sortBy'];
    updateSortByFilter: (filter: IQuestionFilterParams['sortBy']) => void;

    questionText: string;
    updateQuestionText: (q: string) => void;

    newQuestionText: string;
    updateNewQuestionText: (q: string) => void;
}

export const createQuestionsStore = (initState?: Partial<IQuestionsStore>) =>
    createZustandStore<IQuestionsStore>(set => ({
        sortByFilter: QuestionsSortByEnum.NEWEST_FIRST,
        questionText: '',
        newQuestionText: '',

        ...initState,

        updateSortByFilter: filter =>
            set(state => {
                state.sortByFilter = filter;
            }),

        updateQuestionText: q => {
            set(state => {
                state.questionText = q;
            });
        },

        updateNewQuestionText: nQ => {
            set(state => {
                state.newQuestionText = nQ;
            });
        },
    }));

const store = createProvidedStore(createQuestionsStore);
export const useQuestionsStore = store.useStore;
export const QuestionsStoreProvider = store.StoreProvider;
